const SETTINGS_DOMAIN = 'settings'

const SETTINGS_KEY = {
  ALL: 'all',
  CURRENT: 'current',
  DATA: 'data'
}

const SETTINGS_PATH = {
  ALL: `${SETTINGS_DOMAIN}.${SETTINGS_KEY.ALL}`,
  CURRENT: `${SETTINGS_DOMAIN}.${SETTINGS_KEY.CURRENT}`,
  DATA: `${SETTINGS_DOMAIN}.${SETTINGS_KEY.DATA}`
}

const SETTINGS_STATE = {
  [SETTINGS_KEY.ALL]: {
    data: [],
    status: null
  },
  [SETTINGS_KEY.CURRENT]: null,
  [SETTINGS_KEY.DATA]: {}
}

export {
  SETTINGS_DOMAIN,
  SETTINGS_KEY,
  SETTINGS_PATH,
  SETTINGS_STATE
}
